import SplitScreenContent from "../../components/SplitScreenContent";

export const motorRevision911964993 = {
  title: "Motorrevision für luftgekühlte Porsche-Modelle",
  titleImageUrl: "gallery/engine_builds/964_4L/P1020736_dmcacw",
  meta: {
    title: "Porsche 911 / 964 / 993 Motorrevision – WTM Sportwagen",
    description:
      "Motor überholen beim Porsche-Spezialisten: WTM Sportwagen bietet professionelle Motorrevisionen für luftgekühlte 911, 964 & 993 mit Originalteilen und versichertem Hol-/Bringservice.",
  },
  content: [
    {
      type: "hero_image",
      backgroundImage:
        "https://res.cloudinary.com/donwh3eei/image/upload/v1756323701/gallery/frank_kayser/M10_6890_ztzlfu.jpg",
      headline: "Porsche Motorrevision luftgekühlt",
      description:
        "WTM steht für kompromisslose Qualität und echte Expertise bei der Revision von 911, 964 & 993 Motoren. Wir liefern Ergebnisse die höchsten Ansprüchen genügen.",
      hasVignette: true,
      overlayOpacity: 0.04,
    },
    {
      type: "text_section_hero",
      lead: "WTM steht für kompromisslose Qualität und echte Expertise bei der Revision von 911, 964 & 993 Motoren. Wir liefern Ergebnisse die höchsten Ansprüchen genügen.",
      highlight: "Motoren, die halten was sie versprechen.",
      spacing: "tight_top_comfortable_bottom",
      size: "lg",
      variant: "primary",
      margin: false,
    },
    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/M10_6886_1_bchwnz",
      headline: "Motorrevision bei WTM",
      rightContent: (
        <SplitScreenContent
          headline="Präzision in jedem Detail"
          intro="Bei WTM Sportwagen steht jede Motorrevision für kompromisslose Qualität und handwerkliche Perfektion. Unser Fokus liegt auf luftgekühlten Porsche-Motoren der Baureihen 356, 911, 964 und 993. Infos zu modernen wassergekühlten Motoren finden Sie <a href='/motorenbau/motor-instandsetzung-996-997-991-992' class='hyperlink'>hier</a>."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "image",
              src: "gallery/engine_builds/964_sommerfest/IMG_0940_2_lcqrxu",
              alt: "Porsche Motor Revision - Detailarbeit",
              width: 1200,
              height: 800,
              highQuality: true,
            },
            {
              type: "heading",
              text: "Persönlich & Transparent",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Von Beginn an sind Sie Teil des Projekts: mit klarer Kommunikation, WhatsApp-Updates aus der Werkstatt und echtem persönlichen Austausch. So bleibt Ihre Motorrevision nachvollziehbar und vertrauensvoll.",
            },
            {
              type: "heading",
              text: "Handwerk auf Meister-Niveau",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Jeder Arbeitsschritt – von der kompletten Zerlegung bis zum finalen Prüfstandlauf – folgt höchsten Standards. Keine Abkürzungen, keine Kompromisse. Nur ehrliche, deutsche Handwerksqualität.<br/><a href='/motorenbau/getriebe-revision-911-964-993' class='hyperlink'>Gerne revidieren wir im selben Zug auch Ihr Getriebe</a>.",
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline: "Unverbindlich anfragen – wir beraten Sie persönlich",
                paragraph:
                  "Ob komplette Motorrevision oder individuelle Beratung – wir sind persönlich für Sie da. Auf Wunsch mit versichertem Hol- und Bringservice deutschlandweit.",
                darkMode: false,
                margin: false,
              },
            },
            {
              type: "image",
              src: "gallery/frank_kayser/M10_6927_ctimpv",
              alt: "Porsche Motor Revision - WTM Werkstatt",
              width: 600,
              height: 400,
              highQuality: true,
              wrapperClass: "my-24",
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Motorrevision - Porsche 911 Motor",
      navbarHeight: 0,
    },
    {
      type: "text_section_hero",
      headline: "Beispiel: 964 Motorrevision mit 4.0-Liter Umbau",
      lead: (
        <>
          Dieses Beispiel zeigt eine komplette Motorrevision eines 964 Motors
          inklusive 4.0-Liter Umbau und umfangreichem Tuning. <a href='/motorenbau/leistungssteigerungen' class='hyperlink-dark'>Mehr zum Thema Leistungssteigerung</a>.
        </>
      ),

      spacing: "comfortable",
      margin: false,
      size: "md",
      variant: "primary",
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/engine_builds/964_sommerfest/IMG_0966_oeailj",
      headline: "964 Atmo 4.0 RS",
      rightContent: (
        <SplitScreenContent
          headline="Über 400 PS bei 7.200 U/min"
          intro="Jeder Arbeitsschritt – von der kompletten Zerlegung bis zum finalen Prüfstandlauf – folgt höchsten Standards. Keine Abkürzungen, keine Kompromisse. Nur ehrliche, deutsche Handwerksqualität."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "image",
              src: "gallery/engine_builds/964_sommerfest/IMG_0872_2_upkjsj",
              alt: "Porsche Motor Revision - Detailarbeit",
              width: 1200,
              height: 800,
              highQuality: true,
            },
            {
              type: "heading",
              text: "Schmiedeteile für maximale Standfestigkeit",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Kolben, Pleuel und Kurbelwelle – jedes Teil für härteste Belastungen ausgelegt. Diese Basis garantiert Zuverlässigkeit selbst bei hohen Drehzahlen und intensiver Beanspruchung.",
            },
            {
              type: "heading",
              text: "ITBs & Flow-Optimierung",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Einzeldrosselklappen sorgen für direkte Ansprache, Flow-Optimierungen im Zylinderkopf bringen jedes PS ans Licht. Das Ergebnis: ein Motor, der nicht nur stärker, sondern lebendig ist.",
            },
            {
              type: "heading",
              text: "Ästhetik trifft Ingenieurskunst",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Pulverbeschichtete Oberflächen, polierte Details und ein klar strukturierter Motorraum machen die Technik auch optisch zum Statement. Performance, die man sieht – und hört.",
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline: "Unverbindlich anfragen – wir beraten Sie persönlich",
                paragraph:
                  "Ob komplette Motorrevision oder individuelle Beratung – wir sind persönlich für Sie da. Auf Wunsch mit versichertem Hol- und Bringservice deutschlandweit.",
                darkMode: false,
                margin: false,
              },
            },
            {
              type: "image",
              src: "gallery/engine_builds/964_sommerfest/IMG_0874_2_olvsmk",
              alt: "Porsche Motor Revision - WTM Werkstatt",
              width: 600,
              height: 400,
              highQuality: true,
              wrapperClass: "my-24",
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Motorrevision - Porsche 911 Motor",
      navbarHeight: 0,
    },
    {
      type: "relevant-posts",
      postSlugs: [
        "motorrevision-ueberblick",
        "motorschaeden-vermeiden",
        "964-993-leistungssteigerung",
      ], // Array of specific project slugs to show
      headline: "Werkstatt Journal: Porsche-Motoren bei WTM", // Optional custom headline
      introText:
        "Entdecken Sie weitere Artikel zu diesem Thema aus unserem Werkstatt Journal.",
      darkMode: false,
    },
  ],
};
